import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import PatientPage from './PatientPage.js';

export default WithGASetup(PatientPage, AuthContext);
